// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog--dialog--dippN","children":"Dialog--children--s9Xj1","close":"Dialog--close--sYpxI"};